<template>
  <div class="forgot">
    <v-row style="margin-top: 100px">
      <v-col
        lg="4" offset-lg="4"
        md="6" offset-md="3"
        sm="8" offset-sm="2"
        xs="12"
      >
        <v-card
          class="mx-auto"
          outlined
          elevation="1"
        >
          <v-card-title style="background-color: #D4EBE5; color:#02AB98; padding: 0">
            <h5 class="center" >パスワード再設定</h5>
          </v-card-title>
          <validation-observer ref="observer">

            <!-- リセット前のユーザー確認 -->
            <v-card-text v-if="!isSent" class="pa-5">
              <v-alert
                v-if="alert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                style="font-size: 90%"
              >
                {{ error }}
              </v-alert>
              <div style="display:flex; flex-wrap:wrap; width:100%">
                <v-row dense>
                  <v-col cols="12">
                    <v-subheader style="height: 14px" class="text-caption pb-1" >
                      区分を選択
                    </v-subheader>
                  </v-col>
                  <v-btn-toggle
                    v-model="forgotInfo.userClassification"
                    mandatory
                    color="primary"
                    style="margin: 0 auto"
                    class="mb-7"
                  >
                    <v-btn value="本人" width="150" height="35" class="">被保険者（本人）</v-btn>
                    <v-btn value="被扶養者" width="150" height="35" class="">被扶養者（家族）</v-btn>
                  </v-btn-toggle>
                </v-row>
                <v-form @submit.prevent="submit" ref="form">
                  <v-row dense>
                    <v-col cols="4">
                      <validation-provider
                        name="記号"
                        rules="required|max:4|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="forgotInfo.userSymbolId"
                          :error-messages="errors"
                          label="記号"
                          type="tel"
                          name="symbol-id"
                          autocomplete="symbol-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col class="pt-3 pl-2" cols="1">
                      －
                    </v-col>
                    <v-col cols="7">
                      <validation-provider
                        name="番号"
                        rules="required|max:7|numeric"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="forgotInfo.userNumberId"
                          :error-messages="errors"
                          label="番号"
                          type="tel"
                          name="number-id"
                          autocomplete="number-id"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者'">
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        生年月日
                      </v-subheader>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者' && !isMobile">
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                    <v-col cols="4">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(年)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthYear"
                          :items="birthSelectList.year"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(月)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthMonth"
                          :items="birthSelectList.month"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者' && isMobile">
                    <v-col cols="12">
                      <validation-provider
                        name="生年月日(日)"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          v-model="forgotInfo.birthDay"
                          :items="birthSelectList.day"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense v-if="forgotInfo.userClassification=='被扶養者'">
                    <v-col cols="12">
                      <v-subheader style="height: 14px" class="text-caption">
                        性別
                      </v-subheader>
                    </v-col>
                    <v-btn-toggle
                      v-model="forgotInfo.gender"
                      mandatory
                      color="primary"
                      style="margin: 0 auto"
                    >
                      <v-btn width="100" height="30" value="male">男性</v-btn>
                      <v-btn width="100" height="30" value="female">女性</v-btn>
                    </v-btn-toggle>
                  </v-row>
                  <div class="center">
                    <v-btn
                      type="submit"
                      color="primary"
                      class="mt-8"
                      :loading="isLoading"
                    >
                      パスワードリセット
                    </v-btn>
                  </div>
                </v-form>
              </div>
              <div class='authlinks mt-10 text-left'>
                <v-btn text color="primary" @click="signIn">
                  ログイン画面に戻る
                </v-btn>
              </div>
            </v-card-text>

            <!-- 認証コード入力とパスワード設定 -->
            <v-card-text v-if="isSent" class="pa-10">
              <v-alert
                v-if="alert"
                border="left"
                colored-border
                type="error"
                elevation="2"
                style="font-size: 90%"
              >
                {{ error }}
              </v-alert>
              <div>
                <v-form @submit.prevent="verify" ref="confForm">
                  <v-alert
                    border="left"
                    colored-border
                    type="info"
                    elevation="2"
                    style="font-size: 90%"
                    >
                    ご登録いただいているメールアドレスへ認証コードを送信しました。<br>
                    <p style="text-indent: -1em;" class="mt-3 pl-4">
                      <b>※認証コードが届かない場合</b><br/>
                      受信制限されているか、登録されているメールアドレスが存在しない可能性があります。<br/>
                      受信制限されている方は、一度ログイン画面に戻り「@kenchare.net」ドメインを受信できるように設定したうえで、再度パスワード再設定を行ってください。<br/>
                      その他のご事情でメールが届かない場合は、ログイン画面下部のサポートデスクまでお問い合わせください。<br/><br/>
                      <b>メールサーバにより、認証コード受信までに時差が発生することがあります。</b><br/>
                      なお、コードを再送信した場合は、最後に受信した認証コードを入力いただく必要がありますので、ご注意ください。
                    </p>
                  </v-alert>
                  <v-row dense>
                    <v-col cols="12">
                     <validation-provider
                        name="認証コード"
                        rules="required|confirmCode"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="forgotInfo.code"
                          :error-messages="errors"
                          label="認証コード"
                          type="tel"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12">
                      <validation-provider
                        name="新パスワード"
                        :rules="{
                          required: true,
                          min: 8,
                          max: 20,
                          regex: /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\/\'`~!@#$%\^&\*\(\)_\+\-\=\{\}\[\]\\|\:\;\<\>\.\?,]))([a-zA-Z0-9\/\'`~!@#$%\^&\*\(\)_\+\-\=\{\}\[\]\\|\:\;\<\>\.\?,]){8,}$$/
                        }"
                        v-slot="{ errors }"
                        vid="password"
                      >
                        <v-text-field
                          v-model="forgotInfo.password"
                          :append-icon="isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :error-messages="errors"
                          :type="isShowPassword ? 'text' : 'password'"
                          hint="英小文字・英大文字・数字・記号の4種を含め、8文字以上（14文字以上推奨）"
                          @click:append="isShowPassword = !isShowPassword"
                          label="新パスワード"
                          name="password"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                    <v-col cols="12">
                      <validation-provider
                        name="新パスワード"
                        rules="required|confirmed:password"
                        v-slot="{ errors }"
                      >
                        <v-text-field
                          v-model="forgotInfo.passwordConf"
                          :append-icon="isShowPasswordConf ? 'mdi-eye' : 'mdi-eye-off'"
                          :error-messages="errors"
                          :type="isShowPasswordConf ? 'text' : 'password'"
                          hint="英小文字・英大文字・数字・記号の4種を含め、8文字以上（14文字以上推奨）"
                          @click:append="isShowPasswordConf = !isShowPasswordConf"
                          label="新パスワード（確認）"
                          name="password"
                          autocomplete="off"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <div class="center">
                    <v-btn
                      type="submit"
                      color="primary"
                      class="mt-8"
                      :loading="isLoading"
                    >
                      パスワード変更
                    </v-btn>
                  </div>
                </v-form>
              </div>
              <div class='authlinks mt-10 text-left'>
                <v-btn text small color="primary" @click="signIn">
                  ログイン画面に戻る
                </v-btn>
              </div>
            </v-card-text>
          </validation-observer>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Vue from 'vue'
import AmplifyEventBus from './AmplifyEventBus'
import { Auth, I18n } from 'aws-amplify'
import { translate } from '@/i18n'
import { required, max, min, numeric, confirmed, regex } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required', required)
extend('max', max)
extend('min', min)
extend('numeric', numeric)
extend('confirmed', confirmed)
extend('regex', {
  ...regex,
  message: '{_field_}は英小文字・英大文字・数字・記号の4種を含めてください'
})
extend('confirmCode', (value) => {
  const inputCode = value.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
  return /^[0-9０－９]{6}$/.test(inputCode) || '{_field_} は6桁の数字で入力してください'
})

export default Vue.extend({
  name: 'HCForgotPassword',
  props: ['forgotPasswordConfig'],
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      forgotInfo: {
        userClassification: '本人',
        userSymbolId: '',
        userNumberId: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        gender: '',
        code: ''
      },
      birthSelectList: {
        year: [],
        month: [],
        day: []
      },
      isShowPassword: false,
      isShowPasswordConf: false,
      isLoading: false,
      error: '',
      logger: {},
      isSent: false,
      username: '',
      alert: false
    }
  },
  computed: {
    options () {
      const defaults = {
        header: I18n.get('Reset your password')
      }
      return Object.assign(defaults, this.forgotPasswordConfig || {})
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  watch: {
    'forgotInfo.birthYear' () {
      this.getBirthDaySelectList()
    },
    'forgotInfo.birthMonth' () {
      this.getBirthDaySelectList()
    }
  },
  created () {
    // 被扶養者は19歳～75歳が対象
    const todayYear = dayjs().year()
    const yearSelectList = []
    for (let y = todayYear - 76; y <= todayYear - 19; y++) {
      yearSelectList.push({ text: y + '年', value: y })
    }
    this.birthSelectList.year = yearSelectList.reverse()
    for (let m = 1; m <= 12; m++) {
      this.birthSelectList.month.push({ text: m + '月', value: m })
    }
    this.forgotInfo.birthYear = this.birthSelectList.year[0].value
    this.forgotInfo.birthMonth = 1
    this.forgotInfo.birthDay = 1
  },
  mounted () {
  },
  methods: {
    getBirthDaySelectList () {
      const targetDate = `${this.forgotInfo.birthYear}-${this.forgotInfo.birthMonth}-01`
      const maxDay = dayjs(targetDate, 'YYYY-MM-DD').endOf('month').date()
      this.birthSelectList.day = []
      for (let d = 1; d <= maxDay; d++) {
        this.birthSelectList.day.push({ text: d + '日', value: d })
      }
    },
    async submit (e) {
      this.isLoading = true
      this.alert = false
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.alert = true
        this.error = '入力内容にエラーがあります。確認してください。'
        this.isLoading = false
        return false
      }
      let preferredUser = ''
      if (this.forgotInfo.userClassification === '本人') {
        preferredUser = `${this.forgotInfo.userSymbolId}-${this.forgotInfo.userNumberId}`
      } else {
        const birthMonth = `0${this.forgotInfo.birthMonth}`.slice(-2)
        const birthDay = `0${this.forgotInfo.birthDay}`.slice(-2)
        const birtDate = `${this.forgotInfo.birthYear}${birthMonth}${birthDay}`
        preferredUser = `${this.forgotInfo.userSymbolId}-${this.forgotInfo.userNumberId}_${birtDate}_${this.forgotInfo.gender}`
      }
      this.username = preferredUser
      Auth.forgotPassword(preferredUser)
        .then(async (data) => {
          this.isLoading = false
          this.isSent = true
          this.$log.info('forgotPassword success')
        })
        .catch((e) => {
          this.$log.debug('----error forgot----:', e)
          this.setError(e)
        })
    },
    async verify (e) {
      this.isLoading = true
      this.alert = false
      const isValidateError = await this.$refs.observer.validate()
      if (!isValidateError) {
        this.alert = true
        this.error = '入力内容にエラーがあります。確認してください。'
        this.isLoading = false
        return false
      }
      Auth.forgotPasswordSubmit(this.username, this.forgotInfo.code, this.forgotInfo.password)
        .then(async (data) => {
          this.$log.info('forget chagee success')
          this.$emit('passwordChangeSuccessAlert')
          return AmplifyEventBus.$emit('authState', 'signIn')
        })
        .catch((e) => {
          this.$log.debug('---error forgotverify----:', e)
          if (e.code && e.code === 'UserNotConfirmedException') {
            AmplifyEventBus.$emit('localUser', { username: this.options.username })
            AmplifyEventBus.$emit('authState', 'confirmSignUp')
            return false
          } else {
            this.setError(e)
            return false
          }
        })
    },
    signIn () {
      AmplifyEventBus.$emit('authState', 'signIn')
    },
    setError (e) {
      this.isLoading = false
      const errorMessage = I18n.get(e.message || e)
      this.$log.error(errorMessage)
      if (errorMessage === 'Username/client id combination not found.') {
        this.error = `${translate('auth.errors.incorrectIdOrPass')}`
      } else if (errorMessage === 'Incorrect username or password.') {
        this.error = `${translate('auth.errors.incorrectIdOrPass')}`
      } else if (errorMessage === 'User does not exist.') {
        this.error = `${translate('auth.errors.userNotExist')}`
      } else if (errorMessage === 'Password does not conform to policy: Password not long enough') {
        this.error = `${translate('auth.errors.passwordLenghtShort')}`
      } else if (errorMessage === 'Attempt limit exceeded, please try after some time.') {
        this.error = `${translate('auth.errors.limitExceededException')}`
      } else if (errorMessage === 'Invalid verification code provided, please try again.') {
        this.error = `${translate('auth.errors.invalidVerificationCode')}`
      } else {
        this.error = `${translate('auth.errors.unexpectedError')}`
      }
      this.alert = true
    }
  }
})
</script>
<style scoped lang="scss">
.forgot {
  .center {
    margin: 5px auto;
    text-align: center;
  }
}
.authlinks {
  display: block;
  margin-top:10px;
}
button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  background-color: #8AD0B0 !important;
}
button.ma-2.clbtn-main.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
  opacity: 0 ;
}
button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  background-color: #ffed66 !important;
}
button.ma-2.clbtn-dependent.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default::before {
  opacity: 0 ;
}
</style>
